import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const promises = ['Una ruta para armar tu oferta y venderla.', 'Números para no regalar horas ni materiales.', 'Mensajes para convertir curiosas en clientas.', 'Un plan para avanzar todos los días sin sentirte perdida.'];
  return <section className="py-20 md:py-28 bg-coffee-dark text-white relative overflow-hidden" data-id="element-262">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4AF37 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-263"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-265">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-8 leading-tight font-heading text-cream-ivory" data-id="element-266">
            En 30 días podés pasar de "quiero empezar" a{' '}
            <span className="text-gold-matte" data-id="element-267">
              "ya tengo pedidos y sé qué hacer cada semana"
            </span>
            .
          </h2>

          <p className="text-xl md:text-2xl text-beige-sand mb-12 leading-relaxed font-medium" data-id="element-268">
            Esta guía no te promete resultados sin esfuerzo.{' '}
            <span className="font-bold text-white border-b-2 border-gold-matte" data-id="element-269">
              Te promete claridad:
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-270">
          {promises.map((promise, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 flex items-start hover:bg-white/15 transition-colors" data-id="element-271">
              <CheckCircleIcon className="w-8 h-8 text-gold-matte mr-4 flex-shrink-0" data-id="element-272" />
              <p className="text-lg font-semibold text-cream-ivory" data-id="element-273">
                {promise}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}